module.exports = {
  SERVER_PORT: process.env.VUE_APP_SSR_SERVER_PORT || 3000,
  APP_ROOT: process.env.VUE_APP_ROOT,
};
